import {OrderAdditionalCustomerResponseBody} from '@dms/api/sales';
import {CheckoutContractInformationBody} from '@dms/api/shared';

import type {CheckoutPrice} from './CheckoutPrice';
import type {FileData} from './FileData';
import type {OrderDiscriminatorEnum} from './OrderDiscriminatorEnum';
import type {OrderItem} from './OrderItem';
import type {OrderPayment} from './OrderPayment';
import type {TypeOfSaleEnum} from './TypeOfSaleEnum';

export type Order = {
  id: string;
  orderDiscriminator: OrderDiscriminatorEnum;
  depositAllowed: boolean;
  contractInformation: CheckoutContractInformationBody;
  payments: Array<OrderPayment>;
  items: Array<OrderItem>;
  totalPrice: CheckoutPrice;
  files: Array<FileData>;
  typeOfSale: TypeOfSaleEnum;
  addPurchasePaymentAllowed: boolean;
  additionalCustomers: OrderAdditionalCustomerResponseBody[];
  foreignCurrencyPayment: boolean;
  currency: string | null;
  exchangeRateRatioAmount: number | null;
  supplierInvoiceNumber: string | null;
};
